// Keep the whitelisted URLs in this file in sync with KeeperApp/KeeperTax
// File-key uploads use the authorized file resolver instead of this remote-image policy.
const IMAGE_HOSTS = new Set(['keepertax.com', 'www.keepertax.com', 'help.keepertax.com', 'www.swyftfilings.com']);

// These CDNs serve other customers too; trust only Keeper's bucket/space/site prefixes.
const IMAGE_PATH_PREFIXES = {
  'storage.googleapis.com': [
    '/titanium-diode-208122.appspot.com/', // Keeper's production Firebase/Google Cloud Storage assets
    '/keeper-category-icons/' // Keeper's transaction-category icons
  ],
  'images.ctfassets.net': ['/67ehz5zuwb2v/'], // Images in Keeper's Contentful space
  'cdn.prod.website-files.com': [
    '/5cdcb07b95678daa55f2bd83/', // Keeper's Webflow website assets
    '/5cdcb07b95678db167f2bd86/' // Keeper's Webflow CMS assets
  ]
};

export const getAllowedMessageImageUrl = (source) => {
  if (typeof source !== 'string' || !source) {
    return undefined;
  }

  try {
    const url = new URL(source);
    if (url.protocol !== 'https:' || url.username || url.password || url.port) {
      return undefined;
    }
    url.hostname = url.hostname.toLowerCase().replace(/\.$/, '');
    const { hostname, pathname } = url;

    if (
      // Federal, state and local government tax resources, including the IRS
      hostname.endsWith('.gov') ||
      IMAGE_HOSTS.has(hostname) ||
      IMAGE_PATH_PREFIXES[hostname]?.some((prefix) => pathname.startsWith(prefix))
    ) {
      return url.href;
    }
  } catch {
    // Malformed, relative and non-HTTP sources must never reach image loaders.
  }
  return undefined;
};
